
import { defineComponent, PropType } from "vue";
import NumberCountAnimation from "@/data/NumberCountAnimation";
import { getScoreThresholds } from "@/data/games";
import type { ScoreElement } from "@/data/types";
import { mapGetters } from "vuex";
import { getIntScoreColorClass } from "@/helper/scoreColorClass";

export default defineComponent({
  name: "ScoreView",

  data() {
    return {
      gameScoreThresholds: [] as number[],
      scoreCountAnimation: new NumberCountAnimation(0, 0, 0),
      newHighscore: false,
    };
  },

  props: {
    gameName: {
      type: String,
      default: "",
    },
    scoreElements: {
      type: Array as PropType<ScoreElement[]>,
      default: () => [],
    },
  },

  created() {
    this.gameScoreThresholds = getScoreThresholds(this.gameName);
    let score = this.scoreElements.reduce((acc, cur) => {
      return acc + cur.value;
    }, 0);
    let time = this.filteredScoreElements.length * 1000;
    this.scoreCountAnimation = new NumberCountAnimation(0, score, time);
    this.scoreCountAnimation.start();

    if (score > (parseInt(this.highscore) || 0)) {
      this.newHighscore = true;
      this.$store.dispatch("saveHighscore", score);
    }
  },

  computed: {
    ...mapGetters({ highscore: "getHighscore" }),
    scoreClass(): string {
      return getIntScoreColorClass(
        this.calculatedScore,
        this.gameScoreThresholds
      );
    },
    calculatedScore() {
      return this.scoreCountAnimation.current;
    },
    filteredScoreElements() {
      return this.scoreElements.filter((e) => {
        return e.value !== 0;
      });
    },
    flickerClass(): string {
      if (
        this.scoreCountAnimation.current === this.scoreCountAnimation.to &&
        this.calculatedScore >= this.gameScoreThresholds[1]
      ) {
        return "flicker";
      }
      return "";
    },
  },
});
